// import { useEffect, useState } from "react";
// import {
//   Button,
//   Flex,
//   Modal,
//   message,
//   Table,
//   Input,
//   Spin,
//   Tooltip,
//   Popconfirm,
//   Descriptions,
// } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   SearchOutlined,
//   ApiOutlined,
// } from "@ant-design/icons";
// import {
//   postDeviceType,
//   putDeviceType,
//   deleteDeviceType,
//   fetchDeviceType,
//   deviceConnectDisconnectApiCall,
// } from "../Service/deviceType";
// import DeviceTypeForm from "./deviceTypeForm";
// import { TbPlugConnected } from "react-icons/tb";
// import { PiPlugsConnectedBold } from "react-icons/pi";
// import { CgNotes } from "react-icons/cg";
// import usePermission from "../../../../../hooks/usePermission";

// let searchTimeout = null;

// const DeviceType = () => {
//   const { canCreate, canUpdate, canDelete } = usePermission("QUALITY_DEVICE");

//   const [deviceTypes, setDeviceTypes] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(10);
//   const [search, setSearch] = useState(undefined);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isConectModalOpen, setIsConectModalOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();
//   const [deviceConnectRecord, setDeviceConnectRecord] = useState(null);
//   const [sortField, setSortField] = useState("createdDate");
//   const [sortOrder, setSortOrder] = useState("descend");
//   const [serialRecord, setSerialRecord] = useState(null);
//   const [isSerialModalOpen, setIsSerialModalOpen] = useState(false);

//   const showSerialModal = (serialConfig) => {
//     setSerialRecord(serialConfig);
//     setIsSerialModalOpen(true);
//   };
//   const closeSerialModal = () => {
//     setIsSerialModalOpen(false);
//     setSerialRecord(null);
//   };
//   const showModal = (record) => {
//     setDeviceConnectRecord(record);
//     setIsConectModalOpen(true);
//   };
//   const handleConnectCancel = () => {
//     setIsConectModalOpen(false);
//     setDeviceConnectRecord(null);
//     fetchData();
//   };
//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setEditData(null);
//   };

//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     searchText = search,
//     field = sortField,
//     order = sortOrder,
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchDeviceType({
//         page: pageNum - 1,
//         size: pageSize,
//         search: searchText || "",
//         sort: field,
//         desc: order === "descend",
//       });
//       setDeviceTypes(res.data || []);
//       setTotal(res.data?.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//       setSortField(field);
//       setSortOrder(order);
//     } catch {
//       message.error("Network error while fetching device types");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const saveData = async (data) => {
//     setLoading(true);
//     try {
//       if (editData) {
//         await putDeviceType(data, editData.uuid);
//       } else {
//         await postDeviceType(data);
//       }
//       messageApi.success(
//         `Device ${editData ? "updated" : "added"} successfully`,
//       );
//       handleCancel();
//       fetchData();
//     } catch {
//       messageApi.error("Error while saving device type");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const deleteData = async (id) => {
//     try {
//       await deleteDeviceType(id);
//       messageApi.success("Device deleted successfully");
//       fetchData();
//     } catch {
//       messageApi.error("Error while deleting device");
//     }
//   };

//   const connectFn = async () => {
//     try {
//       await deviceConnectDisconnectApiCall(deviceConnectRecord?.uuid, true);
//       message.success("Connected successfully");
//       handleConnectCancel();
//     } catch {
//       message.error("Failed to connect");
//     }
//   };

//   const disConnectFn = async () => {
//     try {
//       await deviceConnectDisconnectApiCall(deviceConnectRecord?.uuid, false);
//       message.success("Disconnected successfully");
//       handleConnectCancel();
//     } catch {
//       message.error("Failed to disconnect");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);
//   useEffect(() => {
//     clearTimeout(searchTimeout);
//     searchTimeout = setTimeout(() => fetchData(1, size, search), 500);
//     return () => clearTimeout(searchTimeout);
//   }, [search]);

//   const columns = [
//     {
//       title: "Device Type",
//       dataIndex: "deviceType",
//       key: "deviceType",
//       sorter: true,
//       sortOrder: sortField === "deviceType" ? sortOrder : null,
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (value) => (value ? "Connected" : "Disconnected"),
//     },
//     {
//       title: "Port",
//       key: "port",
//       sorter: true,
//       render: (_, record) => (
//         <Flex justify="space-between" align="center">
//           {record.serialConfig?.port || "-"}
//           <Button
//             type="link"
//             disabled={!record.serialConfig}
//             onClick={() => showSerialModal(record.serialConfig)}
//           >
//             <CgNotes />
//           </Button>
//         </Flex>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       align: "center",
//       render: (_, record) => (
//         <>
//           <Tooltip title="Connect / Disconnect">
//             <ApiOutlined
//               style={{ marginRight: 12 }}
//               onClick={() => showModal(record)}
//             />
//           </Tooltip>
//           {canUpdate && (
//             <EditOutlined
//               style={{
//                 marginRight: 12,
//                 cursor: record.status ? "not-allowed" : "pointer",
//                 color: record.status ? "#bfbfbf" : undefined,
//               }}
//               onClick={() => {
//                 if (record.status) return;
//                 setEditData(record);
//                 setIsModalOpen(true);
//               }}
//             />
//           )}
//           {canDelete &&
//             (record.status === true ? (
//               <DeleteOutlined
//                 style={{ cursor: "not-allowed", color: "#bfbfbf" }}
//               />
//             ) : (
//               <Popconfirm
//                 title="Delete device"
//                 description="Are you sure?"
//                 okText="Yes"
//                 cancelText="No"
//                 okType="danger"
//                 placement="left"
//                 onConfirm={() => deleteData(record.uuid)}
//               >
//                 <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
//               </Popconfirm>
//             ))}
//         </>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <div style={{ width: "100%" }}>
//         {contextHolder}
//         <Flex
//           justify="space-between"
//           align="center"
//           style={{ marginBottom: 16 }}
//         >
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>
//             Device Configuration
//           </div>
//           <Flex gap={8}>
//             <Input
//               placeholder="Search"
//               prefix={<SearchOutlined />}
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             {canCreate && (
//               <Button type="primary" onClick={() => setIsModalOpen(true)}>
//                 Add
//               </Button>
//             )}
//           </Flex>
//         </Flex>
//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={deviceTypes}
//           bordered
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//           }}
//           onChange={(pagination, _, sorter) =>
//             fetchData(
//               pagination.current,
//               pagination.pageSize,
//               search,
//               sorter.field || sortField,
//               sorter.order || sortOrder,
//             )
//           }
//         />
//         <Modal
//           title={editData ? "Edit device configuration" : "Add new device"}
//           centered
//           open={isModalOpen}
//           footer={false}
//           onCancel={handleCancel}
//         >
//           <DeviceTypeForm editData={editData} saveData={saveData} />
//         </Modal>
//         <Modal
//           title={`Connect ${deviceConnectRecord?.deviceType}`}
//           open={isConectModalOpen}
//           footer={false}
//           width={400}
//           onCancel={handleConnectCancel}
//         >
//           <Spin spinning={loading}>
//             <img
//               alt="connection status"
//               src={`${process.env.PUBLIC_URL}/images/${deviceConnectRecord?.status ? "connected.jpg" : "disconnected.jpg"}`}
//               style={{ width: "100%" }}
//             />
//             <Button
//               type="primary"
//               icon={
//                 deviceConnectRecord?.status ? (
//                   <TbPlugConnected />
//                 ) : (
//                   <PiPlugsConnectedBold />
//                 )
//               }
//               onClick={deviceConnectRecord?.status ? disConnectFn : connectFn}
//               style={{ width: "100%", marginTop: 10 }}
//             >
//               {deviceConnectRecord?.status === true ? "Disconnect" : "Connect"}
//             </Button>
//           </Spin>
//         </Modal>
//         <Modal
//           title="Comport Configuration"
//           open={isSerialModalOpen}
//           onCancel={closeSerialModal}
//           footer={null}
//         >
//           {serialRecord && (
//             <Descriptions column={1} bordered size="small">
//               <Descriptions.Item label="Port">
//                 {serialRecord.port}
//               </Descriptions.Item>
//               <Descriptions.Item label="Baud Rate">
//                 {serialRecord.baudRate}
//               </Descriptions.Item>
//               <Descriptions.Item label="Data Bits">
//                 {serialRecord.dataBits}
//               </Descriptions.Item>
//               <Descriptions.Item label="Stop Bits">
//                 {serialRecord.stopBits}
//               </Descriptions.Item>
//               <Descriptions.Item label="Parity">
//                 {serialRecord.parity}
//               </Descriptions.Item>
//               <Descriptions.Item label="Flow Control">
//                 {serialRecord.flowControl}
//               </Descriptions.Item>
//             </Descriptions>
//           )}
//         </Modal>
//       </div>
//     </Spin>
//   );
// };

// export default DeviceType;

import { useEffect, useState } from "react";
import {
  Button, Flex, Modal, message, Table, Input, Spin, Tooltip, Popconfirm, Descriptions,
} from "antd";
import { EditOutlined, DeleteOutlined, SearchOutlined, ApiOutlined } from "@ant-design/icons";
import {
  postDeviceType, putDeviceType, deleteDeviceType,
  fetchDeviceType, deviceConnectDisconnectApiCall,
} from "../Service/deviceType";
import DeviceTypeForm from "./deviceTypeForm";
import { TbPlugConnected } from "react-icons/tb";
import { PiPlugsConnectedBold } from "react-icons/pi";
import { CgNotes } from "react-icons/cg";
import usePermission from "../../../../../hooks/usePermission";

let searchTimeout = null;

const DeviceType = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("QUALITY_DEVICE");

  const [deviceTypes, setDeviceTypes] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConectModalOpen, setIsConectModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [deviceConnectRecord, setDeviceConnectRecord] = useState(null);
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");
  const [serialRecord, setSerialRecord] = useState(null);
  const [isSerialModalOpen, setIsSerialModalOpen] = useState(false);

  const showSerialModal = (serialConfig) => {
    setSerialRecord(serialConfig);
    setIsSerialModalOpen(true);
  };

  const closeSerialModal = () => {
    setIsSerialModalOpen(false);
    setSerialRecord(null);
  };

  const showModal = (record) => {
    setDeviceConnectRecord(record);
    setIsConectModalOpen(true);
  };

  const handleConnectCancel = () => {
    setIsConectModalOpen(false);
    setDeviceConnectRecord(null);
    fetchData();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditData(null);
  };

  // ✅ FIXED: Proper API handling
  const fetchData = async (
    pageNum = page,
    pageSize = size,
    searchText = search,
    field = sortField,
    order = sortOrder
  ) => {
    setLoading(true);
    try {
      const res = await fetchDeviceType({
        page: pageNum - 1,
        size: pageSize,
        search: searchText || "",
        sort: field,
        desc: order === "descend",
      });

      console.log("API response:", res.data);

      // ✅ IMPORTANT FIX HERE
      const content = res.data?.content || [];
      const totalElements = res.data?.totalElements || 0;

      setDeviceTypes(Array.isArray(content) ? content : []);
      setTotal(totalElements);

      setPage(pageNum);
      setSize(pageSize);
      setSortField(field);
      setSortOrder(order);
    } catch (err) {
      console.error(err);
      message.error("Network error while fetching device types");
    } finally {
      setLoading(false);
    }
  };

  const saveData = async (data) => {
    setLoading(true);
    try {
      if (editData) {
        await putDeviceType(data, editData.uuid);
      } else {
        await postDeviceType(data);
      }
      messageApi.success(`Device ${editData ? "updated" : "added"} successfully`);
      handleCancel();
      fetchData();
    } catch {
      messageApi.error("Error while saving device type");
    } finally {
      setLoading(false);
    }
  };

  const deleteData = async (id) => {
    try {
      await deleteDeviceType(id);
      messageApi.success("Device deleted successfully");
      fetchData();
    } catch {
      messageApi.error("Error while deleting device");
    }
  };

  const connectFn = async () => {
    try {
      await deviceConnectDisconnectApiCall(deviceConnectRecord?.uuid, true);
      message.success("Connected successfully");
      handleConnectCancel();
    } catch {
      message.error("Failed to connect");
    }
  };

  const disConnectFn = async () => {
    try {
      await deviceConnectDisconnectApiCall(deviceConnectRecord?.uuid, false);
      message.success("Disconnected successfully");
      handleConnectCancel();
    } catch {
      message.error("Failed to disconnect");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      fetchData(1, size, search);
    }, 500);
    return () => clearTimeout(searchTimeout);
  }, [search]);

  const columns = [
    {
      title: "Device Type",
      dataIndex: "deviceType",
      key: "deviceType",
      sorter: true,
      sortOrder: sortField === "deviceType" ? sortOrder : null,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => (value ? "Connected" : "Disconnected"),
    },
    {
      title: "Port",
      key: "port",
      sorter: true,
      render: (_, record) => (
        <Flex justify="space-between" align="center">
          {record.serialConfig?.port || "-"}
          <Button
            type="link"
            disabled={!record.serialConfig}
            onClick={() => showSerialModal(record.serialConfig)}
          >
            <CgNotes />
          </Button>
        </Flex>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <>
          <Tooltip title="Connect / Disconnect">
            <ApiOutlined
              style={{ marginRight: 12 }}
              onClick={() => showModal(record)}
            />
          </Tooltip>

          {canUpdate && (
            <EditOutlined
              style={{
                marginRight: 12,
                cursor: record.status ? "not-allowed" : "pointer",
                color: record.status ? "#bfbfbf" : undefined,
              }}
              onClick={() => {
                if (record.status) return;
                setEditData(record);
                setIsModalOpen(true);
              }}
            />
          )}

          {canDelete &&
            (record.status === true ? (
              <DeleteOutlined
                style={{ cursor: "not-allowed", color: "#bfbfbf" }}
              />
            ) : (
              <Popconfirm
                title="Delete device"
                description="Are you sure?"
                okText="Yes"
                cancelText="No"
                okType="danger"
                placement="left"
                onConfirm={() => deleteData(record.uuid)}
              >
                <DeleteOutlined
                  style={{ cursor: "pointer", color: "red" }}
                />
              </Popconfirm>
            ))}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        {contextHolder}

        <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>
            Device Configuration
          </div>

          <Flex gap={8}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {canCreate && (
              <Button type="primary" onClick={() => setIsModalOpen(true)}>
                Add
              </Button>
            )}
          </Flex>
        </Flex>

        <Table
          rowKey="uuid"   // ✅ FIXED
          columns={columns}
          dataSource={deviceTypes} // ✅ Always array now
          bordered
          pagination={{
            current: page,
            pageSize: size,
            total,
            showSizeChanger: true,
          }}
          onChange={(pagination, _, sorter) =>
            fetchData(
              pagination.current,
              pagination.pageSize,
              search,
              sorter.field || sortField,
              sorter.order || sortOrder
            )
          }
        />

        <Modal
          title={editData ? "Edit device configuration" : "Add new device"}
          centered
          open={isModalOpen}
          footer={false}
          onCancel={handleCancel}
        >
          <DeviceTypeForm editData={editData} saveData={saveData} />
        </Modal>

        <Modal
          title={`Connect ${deviceConnectRecord?.deviceType}`}
          open={isConectModalOpen}
          footer={false}
          width={400}
          onCancel={handleConnectCancel}
        >
          <Spin spinning={loading}>
            <img
              alt="connection status"
              src={`${process.env.PUBLIC_URL}/images/${
                deviceConnectRecord?.status
                  ? "connected.jpg"
                  : "disconnected.jpg"
              }`}
              style={{ width: "100%" }}
            />

            <Button
              type="primary"
              icon={
                deviceConnectRecord?.status ? (
                  <TbPlugConnected />
                ) : (
                  <PiPlugsConnectedBold />
                )
              }
              onClick={
                deviceConnectRecord?.status ? disConnectFn : connectFn
              }
              style={{ width: "100%", marginTop: 10 }}
            >
              {deviceConnectRecord?.status ? "Disconnect" : "Connect"}
            </Button>
          </Spin>
        </Modal>

        <Modal
          title="Comport Configuration"
          open={isSerialModalOpen}
          onCancel={closeSerialModal}
          footer={null}
        >
          {serialRecord && (
            <Descriptions column={1} bordered size="small">
              <Descriptions.Item label="Port">{serialRecord.port}</Descriptions.Item>
              <Descriptions.Item label="Baud Rate">{serialRecord.baudRate}</Descriptions.Item>
              <Descriptions.Item label="Data Bits">{serialRecord.dataBits}</Descriptions.Item>
              <Descriptions.Item label="Stop Bits">{serialRecord.stopBits}</Descriptions.Item>
              <Descriptions.Item label="Parity">{serialRecord.parity}</Descriptions.Item>
              <Descriptions.Item label="Flow Control">{serialRecord.flowControl}</Descriptions.Item>
            </Descriptions>
          )}
        </Modal>
      </div>
    </Spin>
  );
};

export default DeviceType;